// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footerPostItem-module--wrapper--1QQwn","title":"footerPostItem-module--title--2r7aC"};